export const scheduling = {
  time: {
    today: 'Hoy',
    tomorrow: 'Mañana',
  },
};
